export const organizationsDataReducer = (state, action) => {
  switch (action.type) {
    case "SET_MY_ORGS_ROLES_DATA": {
      return { ...state, myOrgsRoles: { ...action.payload } };
    }

    case "SET_ORGS_DATA": {
      return { ...state, data: { ...action.payload } };
    }

    case "ADD_ORG": {
      return { ...state, data: [...state.data, action.payload] };
    }
    case "UPDATE_ORG": {
      const updatedData = state.data.map((org) =>
        org.org_id === action.payload.org_id ? action.payload : org
      );
      return { ...state, data: updatedData };
    }
    case "DELETE_ORG": {
      const updatedData = state.data.filter(
        (org) => org.org_id !== action.payload.org_id
      );
      return { ...state, data: updatedData };
    }
    case "CLEAR_ORGS": {
      return { ...state, data: [] };
    }
    case "SET_CURRENT_ORG_DETAIL": {
      return { ...state, currentOrgDetail: action.payload };
    }
    case "UPDATE_CURRENT_ORG_ROBOTS": {
      return {
        ...state,
        currentOrgDetail: {
          ...state.currentOrgDetail,
          robots: action.payload,
        },
      };
    }
    case "UPDATE_CURRENT_ORG_MEMBERS": {
      return {
        ...state,
        currentOrgDetail: {
          ...state.currentOrgDetail,
          members: action.payload,
        },
      };
    }
    case "CLEAR_CURRENT_ORG_DETAIL": {
      return { ...state, currentOrgDetail: null };
    }

    default:
      return state;
  }
};

export const initialOrgsData = {
  data: {
    page: 1,
    per_page: 10,
    total: 0,
    results: [],
  },

  myOrgsRoles: {
    page: 1,
    per_page: 10,
    total: 0,
    results: [],
  },

  currentOrgDetail: {
    org_id: null,
    members: [],
    robots: [],
  },
};
